module.exports = (__webpack_require__(53340))(10);